import type {AxiosInstance} from "axios";
import type {MetlApiExport} from "../metl-models/exports/MetlApiExport.ts";

export interface MetlScheduleApi {
    id: string
    export: () => Promise<MetlApiExport<unknown>>
}

export function metlScheduleApi(axios: AxiosInstance, baseUrl: string, id: string): MetlScheduleApi {
    return {
        id,
        export: async () => {
            const response = await axios.get<MetlApiExport<unknown>>(`${baseUrl}/export`)
            return response.data
        }
    }
}